import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import LogDetail from './section-components/log-detail';
import Footer from './global-components/footer';

const SignInPage = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Log Detail"  />
        <LogDetail />
        <Footer />
    </div>
}

export default SignInPage

